module.exports = __webpack_public_path__ + "img/logo-24.04c609a.jpg";